import { create } from "zustand";

/** Commands of the measurement being taken, available while the measurement tool is mounted */
export type LiveMeasurementActions = {
  /** Complete the measurement as an open polyline */
  finish(): void;

  /** Remove the latest placed point */
  undo(): void;

  /** Restore the latest removed point */
  redo(): void;
};

export type MeasurementGuidanceState = {
  /** Number of points placed in the measurement currently being taken */
  livePointsCount: number;

  /** True if a removed point can be restored */
  canRedo: boolean;

  /** True while the SHIFT projection locks the next point to an axis */
  isAxisLocked: boolean;

  /** Commands of the measurement being taken, undefined if the tool is not mounted */
  actions?: LiveMeasurementActions;
};

/** Ephemeral state the measurement tool shares with its guidance banner and touch toolbar */
export const useMeasurementGuidanceStore = create<MeasurementGuidanceState>()(
  () => ({
    livePointsCount: 0,
    canRedo: false,
    isAxisLocked: false,
  }),
);
